import React, { PropsWithChildren } from "react";

export const PlayIcon: React.FC<PropsWithChildren<React.SVGProps<SVGSVGElement>>> = (props) => (
  <svg width={44} height={44} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 11.2529C12.0004 9.5218 13.8743 8.43909 15.374 9.30371L34.8721 20.5508C36.3728 21.4166 36.3728 23.5824 34.8721 24.4482L15.374 35.6943C13.8742 36.5595 12.0003 35.4775 12 33.7461V11.2529Z"
      fill="#FAFAFA"
    />
  </svg>
);
